var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var parsedErrors = new WeakMap();
var toErrorItems = function (errors) {
    return Array.isArray(errors)
        ? errors.filter(function (item) {
            return typeof item === "object" && item !== null;
        })
        : undefined;
};
var readResponseErrors = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var body, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!response || response.bodyUsed || typeof response.clone !== "function") {
                    return [2 /*return*/, []];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, response.clone().json()];
            case 2:
                body = _c.sent();
                return [2 /*return*/, (_b = toErrorItems(body === null || body === void 0 ? void 0 : body.errors)) !== null && _b !== void 0 ? _b : []];
            case 3:
                _a = _c.sent();
                return [2 /*return*/, []];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Reads the `errors` of a failed request. The ky client throws an HTTPError whose body is still
 * unread in `response`; an error that already carries a parsed `body` is used as it is. The result
 * is cached per error, so it can be read repeatedly. Never throws.
 *
 * @param error the error thrown by the ky client
 * @returns the error items, empty when the error carries none
 */
export var readServerErrors = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var cached, _a, body, response, items, _b;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (typeof error !== "object" || error === null)
                    return [2 /*return*/, []];
                cached = parsedErrors.get(error);
                if (cached)
                    return [2 /*return*/, cached];
                _a = error, body = _a.body, response = _a.response;
                if (!((_c = toErrorItems(body === null || body === void 0 ? void 0 : body.errors)) !== null && _c !== void 0)) return [3 /*break*/, 1];
                _b = _c;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, readResponseErrors(response)];
            case 2:
                _b = (_d.sent());
                _d.label = 3;
            case 3:
                items = _b;
                parsedErrors.set(error, items);
                return [2 /*return*/, items];
        }
    });
}); };
/**
 * The distinct non-blank messages of a failed request, in the order the server sent them.
 */
export var getServerErrorMessages = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var messages;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, readServerErrors(error)];
            case 1:
                messages = (_a.sent())
                    .map(function (item) {
                    return typeof item.message === "string" ? item.message.trim() : "";
                })
                    .filter(function (message) { return message !== ""; });
                return [2 /*return*/, Array.from(new Set(messages))];
        }
    });
}); };
/**
 * Whether the failed request was rejected with an error of the given type (e.g. "-6").
 */
export var hasServerErrorType = function (error, type) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, readServerErrors(error)];
        case 1: return [2 /*return*/, (_a.sent()).some(function (item) { return item.type === type; })];
    }
}); }); };
/**
 * The text of a failed save for the error dialog: the action prefix followed by the messages
 * the server sent (DB-604), or by the error itself when the server sent none.
 *
 * @param prefix the translated action prefix, e.g. "Došlo k chybě při editaci nakladatele. Chyba ze serveru:"
 * @param error the error thrown by the ky client
 */
export var withServerErrorMessages = function (prefix, error) { return __awaiter(void 0, void 0, void 0, function () {
    var messages, detail;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getServerErrorMessages(error)];
            case 1:
                messages = _a.sent();
                detail = messages.length > 0 ? messages.join(" ") : String(error);
                return [2 /*return*/, "".concat(prefix.trimEnd(), " ").concat(detail)];
        }
    });
}); };
